module.exports = __webpack_public_path__ + "static/media/icon-collection.912feeb5.svg";